import React, { useEffect, useRef, useState } from "react";
import Button from "../Ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { ForgetPasswordAction } from "../../redux/Action/AuthAction";
import OtpModel from "./OtpModel";
import { emailValidation } from "../../utils/Validation";
import { VerifyMailType } from "../../constants/Constants";
import $ from "jquery";
import { ImageContainer } from "../../constants/ImagesConstants";
import { FormattedMessage } from "react-intl";

import { useIntl } from "react-intl";

const ForgetPasswordModel = () => {
  const intl = useIntl();

  const dispatch = useDispatch<any>();
  const forgetPassword = useSelector((state: any) => state.ForgetPasswordState);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError]: any = useState("");
  const [emailPayload, setEmailPayload]: any = useState(null);
  const [onModelClose, setOnModelClose] = useState(false);

  const sendOtpButton: any = useRef(null);

  /* =============== Handle email on change start =============== */
  const handleEmail = (value: any) => {
    setEmail(value);
    setEmailError("");
    setEmailError(emailValidation(value));
  };
  /* =============== Handle email on change end =============== */

  /* =============== Handle onsubmit start =============== */
  const handleSubmit = () => {
    if (emailValidation(email)) {
      setEmailError(emailValidation(email));
    } else {
      setEmailPayload(null);
      setOnModelClose(false);
      dispatch(ForgetPasswordAction({ email: email }));
    }
  };
  /* =============== Handle onsubmit end =============== */

  /* =============== Send and handle data on submit start =============== */
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };
  /* =============== end =============== */

  useEffect(() => {
    if (forgetPassword?.status) {
      const payload = {
        email,
        type: VerifyMailType?.ForgetPasswordVerify,
        setOnModelClose,
      };
      setEmailPayload(payload);
      $(".btnClose").click();
      if (sendOtpButton.current) {
        sendOtpButton.current.click();
      }
    }
  }, [forgetPassword]);

  useEffect(() => {
    if (onModelClose) {
      setEmailPayload(null);
    }
  }, [onModelClose]);

  useEffect(() => {
    return () => {
      dispatch(ForgetPasswordAction("RESET"));
    };
  }, []); // Reset data

  return (
    <>
      <div
        className="modal modelStyle fade"
        id="forgotpassword"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel1"
        data-bs-backdrop="static"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btnClose"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setEmailError("");
                  setEmail("");
                }}
              >
                <span className="icon-close"></span>
              </button>
              <div className="row">
                <div className="col-md-8 mx-auto text-center">
                  <div className="modelLogo">
                    <img src={ImageContainer?.Logo} />
                  </div>
                  <h2>
                    <FormattedMessage id="Forgot_password" />
                  </h2>
                  <p>
                    <FormattedMessage id="forgot_password_message_first" />
                    <br /> <FormattedMessage id="to_receive_otp" />
                  </p>
                  <div className="my-5 inputIcon">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder={intl.formatMessage({
                        id: "enter_email_address",
                      })}
                      onChange={(e: any) => handleEmail(e.target.value)}
                      value={email}
                      onKeyDown={handleKeyDown}
                    />
                    <span className="iconLeft icon-email"></span>
                    <p className="text-danger"> {emailError}</p>
                  </div>
                  {/* <button type="submit" className="btn btn-fill mb-4" onClick={handleSubmit}>Submit</button> */}
                  <Button
                    type="submit"
                    className="btn btn-fill mb-4"
                    onClick={handleSubmit}
                    text={(<FormattedMessage id="submit" />) as any}
                    isLoading={forgetPassword?.loading}
                  />
                  <button
                    type="button"
                    style={{ display: "none" }}
                    data-bs-toggle="modal"
                    data-bs-target="#OTPVerify"
                    className="btn btn-fill w-100 my-4"
                    ref={sendOtpButton}
                  >
                    {<FormattedMessage id="submit" />}
                  </button>

                  {/* <button type="button" style={{ display: 'none' }} className="btn btn-fill mb-4" data-bs-target="#ResetPassword" data-bs-toggle="modal" ref={resetPasswordButton}>Submit</button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OtpModel payload={emailPayload} />
    </>
  );
};

// export default ForgetPasswordModel
export default React.memo(ForgetPasswordModel);
